export default "__VITE_ASSET__C$4kQWR6NkPB83QJdL0WCQ__";